import { getSubdomain } from '@ps/tools/helpers/getSubdomain'
import { create } from 'zustand'
import { PersistOptions, persist } from 'zustand/middleware'

const baseURL = import.meta.env.VITE_API_BASE_URL

const key = getSubdomain(baseURL)

export type AuthStoreType = {
  id: string | null
  email: string | null
  token: string | null
  login: (token: string) => void
  logout: () => void
  getToken: () => string | null
  getID: () => string | null
  setID: (id: string) => void
  setEmail: (email: string | null) => void
}

export const useAuthStore = create(
  persist(
    (set, get) => ({
      id: null,
      email: null,
      token: null,
      login: (token: string) => set({ token }),
      logout: () => set({ token: null, id: null, email: null }),
      getToken: () => get().token,
      getID: () => get().id,
      setID: (id: string) => set({ id }),
      setEmail: (email: string | null) => set({ email }),
    }),
    {
      name: key,
    } as PersistOptions<AuthStoreType, AuthStoreType>,
  ),
)
